<template>
    <div class="CoverageFormat">
      <Helmet>
        <title>Internet Services and Coverage in Mozambique - inte-QT</title>
        <meta name="title" content="Internet Services and Coverage in Mozambique - inte-QT" />
        <meta
          name="description"
          content="Explore internet connectivity and broadband solutions in Mozambique. Discover available internet providers, mobile services, and submarine cable infrastructure."
        />
        <meta
          name="keywords"
          content="internet in Mozambique, broadband Mozambique, internet services Mozambique, mobile internet Mozambique, submarine cables Mozambique, internet providers Mozambique"
        />
        <link rel="canonical" href="https://www.inte-qt.com/coverage/mozambique" />
      </Helmet>
  
      <img
        src="/images/0nJcdAY.jpg"
        alt="bigbanner-background"
        class="banner-img CoverageFormat__saturation"
      />
  
      <section class="mt-5">
        <nav class="container">
          <ul>
            <li><strong>POPULATION</strong> - Projected to be <strong>32.90 Million*</strong> in 2022.</li>
            <li><strong>NEIGHBOURING COUNTRIES*</strong> - Borders Tanzania, Malawi, Zambia, Zimbabwe, South Africa, and Eswatini.</li>
            <li><strong>LANGUAGE SPOKEN</strong> - Portuguese (official), plus Makhuwa, Changana, Nyanja, etc.</li>
            <li><strong>CURRENCY</strong> - Mozambican Metical (MZN).</li>
            <li><strong>INDUSTRIES</strong> - Aluminum, Coal, Chemicals, Cement, Textiles, Food, etc.</li>
            <li>
              <strong>TOP 3 CITIES</strong>
              <ul>
                <li>Matola: 1.6M</li>
                <li>Maputo: 1.1M</li>
                <li>Nampula: 743k</li>
              </ul>
            </li>
            <li><strong>WEATHER</strong> - Tropical to subtropical, with two main seasons.</li>
            <li><strong>EMPLOYMENT</strong> - 2.49% employer rate (2020).</li>
          </ul>
  
          <div class="text-center">
            <img
              src="https://gistcdn.githack.com/juan-bits/33346827618f5264eb8092378f7cc886/raw/2b774ef5a71df83f27b9aaf42882634e25da6dc8/mozambique-flag.svg"
              alt="Mozambique flag"
              class="my-5 CoverageFormat__flag"
              style="width: 150px"
            />
          </div>
        </nav>
  
        <article>
          <p>Mozambique, a scenic country in southeastern Africa, is rich in resources and culture.</p>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7745571.310902386!2d31.312295239100607!3d-18.573261404275097!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x18d4aceae6fd4ac5%3A0x12bbbfb9ae16a115!2sMozambique!5e0!3m2!1sen!2ses!4v1648814378083!5m2!1sen!2ses"
            width="95%"
            height="450"
            class="CoverageFormat__margins"
            style="border: 0"
            loading="lazy"
            allowfullscreen
            title="mozambique-map"
          ></iframe>
  
          <h4 class="mt-4">Tourism</h4>
          <p>2 million tourists visited in 2019. Growth is ongoing.</p>
  
          <h4 class="mt-4">Main Ports / Airports</h4>
          <table class="table">
            <thead>
              <tr><th>IATA</th><th>Name</th><th>City</th></tr>
            </thead>
            <tbody>
              <tr><td>MPM</td><td>Maputo Airport</td><td>Maputo</td></tr>
              <tr><td>APL</td><td>Nampula Airport</td><td>Nampula</td></tr>
              <tr><td>POL</td><td>Pemba Airport</td><td>Pemba</td></tr>
              <tr><td>BEW</td><td>Beira Airport</td><td>Beira</td></tr>
            </tbody>
          </table>
  
          <p>Key ports: Maputo, Beira, Nacala, and others.</p>
  
          <h4 class="mt-5">National Sport</h4>
          <p>Football (soccer). Eusebio famously represented Mozambique.</p>
  
          <h4 class="mt-5">Typical Food</h4>
          <p>Xima – corn flour-based staple.</p>
        </article>
      </section>
  
      <div class="container">
        <h4 class="my-5">Submarine Cables</h4>
        <a
          href="https://www.submarinecablemap.com/country/mozambique"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/images/okZoBA5.png" alt="submarine cables" width="100%" />
        </a>
  
        <ol class="mt-4">
          <li>2Africa</li>
          <li>EASSy</li>
          <li>SEACOM / Tata TGN-Eurasia</li>
        </ol>
  
        <h4 class="my-4">Access to Internet</h4>
        <p>Telecom reform supports growing mobile & broadband access.</p>
  
        <h4 class="my-4">Internet Providers</h4>
        <p>5.36 million users as of Jan 2020.</p>
  
        <h4 class="my-4">Our Capabilities</h4>
        <p>Download: 16.03 Mbps | Upload: 10.56 Mbps</p>
        <p>Services: broadband, dedicated lines, wireless, and more.</p>
  
        <table class="table table-striped mb-5">
          <tbody>
            <tr><td>Dedicated Lines</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>Business Broadband</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>Wireless Connectivity</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>SLA</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>CPE / Router</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>GEMS</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>Diverse Gateway Solutions</td><td><i class="fas fa-check"></i></td></tr>
            <tr><td>DDoS</td><td><i class="fas fa-check"></i></td></tr>
          </tbody>
        </table>
  
        <p class="CoverageFormat__tag CoverageFormat__margins text-center" align="justify">
          With our Global Business Solutions team, get a <mark>Commercial Offer in 2-3 working days</mark>. Delivery: Maputo & Matola in 2-3 weeks, others 4-5 weeks.
        </p>
  
        <p class="text-center">
          For more information, <a href="mailto:sales@inte-QT.com?subject=Mail from Our Site">Email Us</a>.
        </p>
  
        <h4>* - References</h4>
        <ul>
          <li><a href="https://www.worldbank.org/en/country/mozambique/overview#1" target="_blank">Reference 1</a></li>
          <li><a href="https://www.budde.com.au/Research/Mozambique-Telecoms-Mobile-and-Broadband-Statistics-and-Analyses" target="_blank">Reference 2</a></li>
          <li><a href="https://www.britannica.com/place/Mozambique" target="_blank">Reference 3</a></li>
        </ul>
      </div>
  
      <GetInTouch />
    </div>
  </template>
  
  <script setup>
  
  import { useHead } from '@vueuse/head'
  import GetInTouch from '@/components/GetInTouch.vue'
  
  useHead({
    title: 'Internet Services and Coverage in Mozambique - inte-QT',
    meta: [
      {
        name: 'description',
        content:
          'Explore internet connectivity and broadband solutions in Mozambique. Discover available internet providers, mobile services, and submarine cable infrastructure.',
      },
      {
        name: 'keywords',
        content:
          'internet in Mozambique, broadband Mozambique, internet services Mozambique, mobile internet Mozambique, submarine cables Mozambique, internet providers Mozambique',
      },
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.inte-qt.com/coverage/mozambique',
      },
    ],
  })
  </script>
  
  <style scoped>
  .CoverageFormat {
  color: black;
}

.CoverageFormat__title {
  position: absolute;
  width: 50vw;
  top: 15vh;
  left: 25vw;
  line-height: 1.5;
  font-size: 3rem;
  font-weight: 500; 
  color: #ffffff;  
}

@media (max-width: 992px) {
  .CoverageFormat__title {
    font-size: 3rem;
    width: 40vw;
    top: 30vh;
    left: 55vw;
  }
}

@media (max-width: 768px) {
  .CoverageFormat__title {
    font-size: 2rem;
    width: 40vw;
    top: 25vh;
    left: 55vw;
  }
}

@media (max-width: 576px) {
  .CoverageFormat__title {
    top: 12vh;
    left: 5vw;
    width: 90vw;
    font-size: 1.5rem;
  }
}

.CoverageFormat__tag {
  font-size: 1.5rem;
}

.CoverageFormat section {
  display: -webkit-flex;
  display: flex;
}

.CoverageFormat nav {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.CoverageFormat nav ul {
  padding: 0;
}

.CoverageFormat ul li,
.CoverageFormat ol li {
  margin: 1rem;
  text-align: left;
}

.CoverageFormat article {
  color: black;
  -webkit-flex: 3;
  -ms-flex: 3;
  flex: 3;
  padding: 10px;
}

.CoverageFormat__saturation {
  filter: drop-shadow(1px 10px 40px rgb(0, 0, 0)) saturate(110%);
}

.CoverageFormat__margins {
  margin: 3rem;
}

@media (max-width: 768px) {
  .CoverageFormat__margins {
    margin: 1rem 0 1rem 0;
    text-align: left;
  }
}

.CoverageFormat__flag {
  width: 150px;
  border: 1px solid black;
}

@media (max-width: 768px) {
  .CoverageFormat section {
    -webkit-flex-direction: column;
    flex-direction: column;
  }
}
  </style>
  